export default __webpack_public_path__ + "static/PavelIvanov-d26e9a6c3967bd917f98e18fb9515bf6.png";